@switch (type()) {
	@case ('h1') {
		<h1
			[ngClass]="{ 'overflow-hidden text-ellipsis whitespace-nowrap': ellipsis() }"
			[class]="styles()"
		>
			<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
		</h1>
	}
	@case ('h2') {
		<h2
			[ngClass]="{ 'overflow-hidden text-ellipsis whitespace-nowrap': ellipsis() }"
			[class]="styles()"
		>
			<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
		</h2>
	}
	@case ('h3') {
		<h3
			[ngClass]="{ 'overflow-hidden text-ellipsis whitespace-nowrap': ellipsis() }"
			[class]="styles()"
		>
			<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
		</h3>
	}
	@case ('h4') {
		<h4
			[ngClass]="{ 'overflow-hidden text-ellipsis whitespace-nowrap': ellipsis() }"
			[class]="styles()"
		>
			<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
		</h4>
	}
}

<ng-template #contentTpl>
	<ng-content></ng-content>
</ng-template>
